import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Box } from "@mui/material";
import moment from "moment";
import {
  convertedDateToMonthyearFormat2,
  errorMessage2,
} from "app/utils/utils";
import React from "react";
import { COLORS, FONTS } from "app/views/dashboard/shared/tokens";

const stepBtnSx = {
  width: 28,
  height: 28,
  borderRadius: "8px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  color: COLORS.body2,
  border: "none",
  background: "transparent",
  "&:hover": { background: "#f8f5fd", color: COLORS.ink3 },
};
const stepBtnOffSx = { ...stepBtnSx, color: "#dcd3ee", cursor: "default", pointerEvents: "none", "&:hover": {} };

const Datefilter = ({
  dateFieldError,
  setDateFieldError,
  maxDate = new Date(),
  page,
  setPage,
  selectedMonth,
  setSelectedMonth,
  // Opt-in only — every existing caller keeps the calendar month/year picker
  // below unchanged. Pass variant="stepper" for a prev/next arrow control
  // (no calendar dropdown), matching the admin attendance page's date control.
  variant = "calendar",
  //   errorMessage2
}) => {
  if (variant === "stepper") {
    const current = selectedMonth ? new Date(selectedMonth) : new Date();
    const isCurrentMonth = moment(current).isSame(moment(), "month");

    const step = (dir) => {
      const next = moment(current).add(dir, "month").toDate();
      setDateFieldError("");
      setPage(0);
      setSelectedMonth(convertedDateToMonthyearFormat2(next));
    };

    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
        <Box component="button" type="button" sx={stepBtnSx} onClick={() => step(-1)} aria-label="Previous month">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round"><path d="M14 6l-6 6 6 6" /></svg>
        </Box>
        <Box component="span" sx={{ display: "flex", alignItems: "center", gap: "8px", fontFamily: FONTS.body, fontSize: "13.5px", fontWeight: 600, color: COLORS.ink3, px: "4px", minWidth: "140px", justifyContent: "center" }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#a411c1" strokeWidth="2" strokeLinecap="round"><rect x="3.5" y="5" width="17" height="15" rx="2.5" /><path d="M3.5 10h17M8.5 3v4M15.5 3v4" /></svg>
          {moment(current).format("MMMM YYYY")}
        </Box>
        <Box
          component="button"
          type="button"
          sx={isCurrentMonth ? stepBtnOffSx : stepBtnSx}
          onClick={isCurrentMonth ? undefined : () => step(1)}
          aria-label="Next month"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round"><path d="M10 6l6 6-6 6" /></svg>
        </Box>
      </Box>
    );
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        format="MM/yyyy"
        value={!!selectedMonth ? new Date(selectedMonth) : null}
        // label={"Month and Year"}
        views={["year", "month"]}
        openTo="month"
        onError={(newError) => {
          newError ? setDateFieldError(newError) : setDateFieldError("");
        }}
        slotProps={{
          textField: {
            variant: "standard",
            helperText: errorMessage2(dateFieldError),
            error: !!dateFieldError ? true : false,
            onChange: (newVal, validate) => {
              const { validationError } = validate || {};
              validationError
                ? setDateFieldError(validationError)
                : setDateFieldError("");
              setPage(0);
              setSelectedMonth(convertedDateToMonthyearFormat2(newVal));
            },
          },
        }}
        onAccept={(newVal) => {
          setPage(0);
          setSelectedMonth(convertedDateToMonthyearFormat2(newVal));
        }}
        // maxDate={maxDate}
      />
    </LocalizationProvider>
  );
};

export default Datefilter;
